import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import ConversionDialog from 'components/Modals/ConversionDialog';
import { locations } from 'services/routes/locations';

const AccountDeletedModal = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleNavigation = () => {
    navigate(locations.general.discovery.pathname);
  };

  return (
    <ConversionDialog
      title={t('account:accountDeletedModal:title')}
      state={{
        isOpen: true,
        error: null,
        isLoading: false,
      }}
      action={{
        onSubmit: handleNavigation,
        onClose: handleNavigation,
        onExited: handleNavigation,
      }}
      description={t('account:accountDeletedModal:description')}
      submitText={t('general:action:continue')}
    />
  );
};

export default AccountDeletedModal;
